import el from "@cypherpotato/el";
import page from "page";
import { api } from "../../../api";
import { Button } from "../../../components/button";
import { Card, CardContent } from "../../../components/card";
import { CommandBar } from "../../../components/command-bar";
import { Dashboard, DashboardTitle } from "../../../components/dashboard";
import { Editor, EditorDescription, EditorTitle } from "../../../components/editor";
import { TextInput } from "../../../components/form";
import { Icon } from "../../../components/icon";
import { Section } from "../../../components/layout";
import { ExternalLink, Link } from "../../../components/link";
import { DashboardTextHeading, Paragraph } from "../../../components/text";
import { TimeSpanPicker } from "../../../components/time-span-picker";
import { displayFormControl } from "../../../ui/alert";
import { formatDuration } from "../../../ui/format";
import { runOperation } from "../../../ui/operation";
import { pipeWhenTrue, valueFrom } from "../../../util";


export default function (ctx) {

    const chatClientId = ctx.params.id;
    const chatClient = el.state.create(null);

    function updateView() {
        runOperation("Fetching chat client...", async () => {
            const response = await api.getJson(`/api/v1/web-chat-client/${chatClientId}`);
            chatClient.value = response.data;
        });
    }

    updateView();

    function handleSave() {
        const data = {
            integrationType: "Telegram",
            integrations: {
                telegramIntegration:
                    pipeWhenTrue(valueFrom("tgBotToken"), botToken => {
                        return {
                            botToken,
                            sessionDuration: valueFrom("tgSessionDuration")
                        }
                    })
            }
        };

        runOperation("Saving Telegram integration details...", async () => {
            await api.putJson(`/api/v1/web-chat-client/${chatClientId}/integrations`, data);
        });
    }

    return el.state.listening([chatClient], () =>
        Dashboard(
            Section(
                Link(el.fragment(Icon("arrow-left-line"), "Return back"), null, {
                    onClick() {
                        history.go(-1);
                        page();
                    }
                })
            ),
            DashboardTitle(
                DashboardTextHeading("Telegram settings", chatClient.value?.name)
            ),
            Section(
                CommandBar(
                    Button(
                        Icon("save-line"),
                        "Save changes",
                        {
                            onClick: handleSave
                        }
                    ),
                    Button(
                        Icon("link-unlink"),
                        "Update hooks",
                        {
                            onClick() {
                                runOperation("Updating bot preferences...", async () => {
                                    await api.postJson(`/api/v1/intl/tg/${chatClientId}/update`);
                                });
                            }
                        }
                    )
                )
            ),
            Section(
                Card(
                    CardContent(
                        Paragraph(
                            "To set up your chat-client in a Telegram bot you first need to create a bot with the ",
                            ExternalLink("@BotFather", "https://telegram.me/BotFather"), "."
                        ),
                        Paragraph(
                            "After doing this, set the token of the bot created below, update the pointers with the available button ",
                            "on this page and your bot will be ready."
                        )
                    )
                )
            ),
            Section(
                Editor(
                    {
                        id: "tgBotToken",
                        value: chatClient.value?.integrations.telegramIntegration?.botToken,
                        renderValue(value) {
                            return Button("👀");
                        },
                        manipulateValue(value, callback) {
                            displayFormControl({
                                title: this.editorTitle,
                                message: this.editorParagraphs,
                                formControlItem: TextInput(null, "812998b812:AAEno9bX...As_5c7do64E", { value }),
                                onConfirm: callback,
                                validate: [
                                    [x => x.length > 3, "The bot token must be at least 3 characters long."]
                                ],
                                nullButton: true
                            })
                        }
                    },
                    EditorDescription(
                        EditorTitle("Bot token"),
                        Paragraph("Specify the ID of the instance where WhatsApp is connected.")
                    )
                )
            ),
            Section(
                Editor(
                    {
                        id: "tgSessionDuration",
                        value: chatClient.value?.integrations.telegramIntegration?.sessionDuration || 10800,
                        renderValue(value) {
                            return Button(formatDuration(value));
                        },
                        manipulateValue(value, callback) {
                            displayFormControl({
                                title: this.editorTitle,
                                message: this.editorParagraphs,
                                formControlItem: TimeSpanPicker({ value: value }),
                                onConfirm: callback,
                                validate: [
                                    [x => x >= 600, "The duration must be greater than or equal to 10 minutes."],
                                    [x => x <= 7776000, "The duration must be less than or equal to 90 days."],
                                ]
                            })
                        }
                    },
                    EditorDescription(
                        EditorTitle("Session duration"),
                        Paragraph("Specify the duration that a conversation has before being restarted.")
                    )
                ),
            )
        )
    )
}